import React from "react"
import {
    AppNotificationsDrawerProvider,
    AppMainHotelsProvider,
    AppLastUpdateProvider,
    AppCurrencyProvider,
    AppMarketProvider,
    AppDatesProvider,
    AppRefreshDataProvider,
    AppLocationDataProvider,
    AppReportExecutionProvider
} from "./@contexts"
import { AppTourProvider } from "app/@tour"


export default function AppProviders({ children }) {

    return <AppTourProvider>
        <AppNotificationsDrawerProvider>
            <AppMainHotelsProvider>
                <AppLastUpdateProvider>
                    <AppCurrencyProvider>
                        <AppMarketProvider>
                            <AppDatesProvider>
                                <AppRefreshDataProvider>
                                    <AppLocationDataProvider>
                                        <AppReportExecutionProvider>
                                            {children}
                                        </AppReportExecutionProvider>
                                    </AppLocationDataProvider>
                                </AppRefreshDataProvider>
                            </AppDatesProvider>
                        </AppMarketProvider>
                    </AppCurrencyProvider>
                </AppLastUpdateProvider>
            </AppMainHotelsProvider>
        </AppNotificationsDrawerProvider>
    </AppTourProvider>
}

export {
    AppCurrencyContext, AppMainHotelsContext, AppDatesContext,
    AppLastUpdateContext, AppMarketContext,
    AppNotificationsDrawerContext, AppRefreshDataContext, AppLocationDataContext,
    AppReportExecutionContext
} from "./@contexts"
